const getOffset = (el) => {
    var offsetX = el.offsetLeft, offsetY = el.offsetTop, _el = el;

    while (_el.offsetParent) {
        _el = _el.offsetParent;
        offsetX += _el.offsetLeft;
        offsetY += _el.offsetTop;
    }

    return {x: offsetX, y: offsetY};
}

export default getOffset;